import React from "react";

const DisplayLanguagesSection = ({
  languages = [],
  toolType,
  tool,
  setTool,
  handleSubmitBtnState,
}) => {
  const getPageText = (toolType) => {
    switch (toolType) {
      case "VideoToolbox":
        return "video";
      case "ImageToolbox":
        return "image";
      case "TextToolbox":
        return "text";
      case "EmbedToolbox":
        return "embed";
      case "HotspotToolbox":
        return "hotspot";
      case "HotspotToolbox":
        return "hotspot";
    }
  };
  const selectedLanguageIds = Array.isArray(tool?.other_files)
    ? tool.other_files
    : [];

  const toggleLanguage = (docFileId) => {
    if (!docFileId || typeof setTool !== "function") return;

    setTool((prev) => {
      const current = Array.isArray(prev?.other_files)
        ? prev.other_files
        : [];
      const exists = current.includes(docFileId);
      const updated = exists
        ? current.filter((id) => id !== docFileId)
        : [...current, docFileId];

      return {
        ...prev,
        other_files: updated,
        other_files_element: [...updated],
      };
    });

    if (typeof handleSubmitBtnState === "function") {
      handleSubmitBtnState();
    }
  };

  return (
    <div className="animation-select">
      <p>
        Display this {getPageText(toolType)} on the following language editions
        of this KDF:
      </p>
      <div>
        {languages?.map((lang, index) => {
          const docFileId = lang?.id ?? lang?.docs_file_id;
          if (!docFileId) return null;
          const inputId = `language-checkbox-${docFileId}`;
          const isChecked = selectedLanguageIds.includes(docFileId);
          const tooltip =
            lang?.count_live_files === 0
              ? "This language edition needs to be published before it can be shared"
              : null;

          return (
            <label
              key={docFileId ?? index}
              htmlFor={inputId}
              className="d-flex gap-3 align-items-center cursor-pointer"
              title={tooltip ?? undefined}
            >
              <input
                type="checkbox"
                className="fs-5"
                id={inputId}
                checked={isChecked}
                onChange={() => toggleLanguage(docFileId)}
              />
              <div
                style={{
                  width: "18px",
                  height: "25px",
                }}
                className={lang?.language?.class}
              ></div>
              <span className="fs-6 mb-0">
                {lang?.language?.name ?? "English (US)"}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
};
export default DisplayLanguagesSection;
